export default {
      id: "format-list-numbered-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#format-list-numbered-usage",
      toString: function () {
        return this.url;
      }
    }